<template>
    <div class="card my-1">
        <div class="card-header text-white text-center app-class-summary-panel-headings">
            <h4><strong>GENERAL MANAGEMENT</strong></h4>
        </div>
        <div class="card-body app-class-summary-panel-body">
            <v-simple-table>
                <template v-slot:default>
                    <tbody>
                        <tr>
                            <td class="app-class-summary-panel-text-bold text-left">
                                NHMIS Health facility monthly summary form
                            </td>
                            <td class="app-class-text-light text-right">
                                <ComponentColorCoderBool 
                                v-bind:prop_qst_model="data_qst_1" 
                                v-bind:prop_qst_show_bools_as_sym="true"/>
                            </td>
                        </tr>
                        <tr>
                            <td class="app-class-summary-panel-text-bold text-left">
                                NHMIS health facility daily attendance register
                            </td>
                            <td class="app-class-text-light text-right">
                                <ComponentColorCoderBool 
                                v-bind:prop_qst_model="data_qst_2" 
                                v-bind:prop_qst_show_bools_as_sym="true"/>
                            </td>
                        </tr>
                        <tr>
                            <td class="app-class-summary-panel-text-bold text-left">
                                NHMIS health facility daily GMP (growth monitoring) register
                            </td>
                            <td class="app-class-text-light text-right">
                                <ComponentColorCoderBool 
                                v-bind:prop_qst_model="data_qst_3" 
                                v-bind:prop_qst_show_bools_as_sym="true"/>
                            </td>
                        </tr>
                        <tr>
                            <td class="app-class-summary-panel-text-bold text-left">
                                NHMIS health facility Immunization register
                            </td>
                            <td class="app-class-text-light text-right">
                                <ComponentColorCoderBool 
                                v-bind:prop_qst_model="data_qst_4" 
                                v-bind:prop_qst_show_bools_as_sym="true"/>
                            </td>
                        </tr>
                        <tr>
                            <td class="app-class-summary-panel-text-bold text-left">
                                NHMIS health facility labour/delivery register
                            </td>
                            <td class="app-class-text-light text-right">
                                <ComponentColorCoderBool 
                                v-bind:prop_qst_model="data_qst_5" 
                                v-bind:prop_qst_show_bools_as_sym="true"/>
                            </td>
                        </tr>
                    </tbody>
                </template>
            </v-simple-table>
        </div>
    </div>
</template>

<script>
//########################################
//IMPORTS libs
//########################################

//GENERIC COMPONENTS
import ComponentColorCoderBool from '@/components/ComponentColorCoderBool';

//########################################
//IMPORTS components
//########################################

//########################################
//MAIN
//########################################
export default {
    name: 'ComponentSummary1',

    props:[
        'prop_submission'
    ],

    components:{
        //GENERIC COMPONENTS
        ComponentColorCoderBool
    },

    data: function()
    {
        return {
        }
    },

    computed:{
        data_qst_1:function()
        {
            return this.prop_submission == undefined || this.prop_submission.length == 0 ? undefined : this.prop_submission[0].qsts_all["GroupGener0/NHMISnhmis9/NHMISmsfHea"];
        },
        data_qst_2:function()
        {
            return this.prop_submission == undefined || this.prop_submission.length == 0 ? undefined : this.prop_submission[0].qsts_all["GroupGener0/NHMISnhmis9/NHMISfacHea"];
        },
        data_qst_3:function()
        {
            return this.prop_submission == undefined || this.prop_submission.length == 0 ? undefined : this.prop_submission[0].qsts_all["GroupGener0/NHMISnhmis9/NHMIgmpHeal"];
        },
        data_qst_4:function()
        {
            return this.prop_submission == undefined || this.prop_submission.length == 0 ? undefined : this.prop_submission[0].qsts_all["GroupGener0/NHMISnhmis9/NHMISimmHea"];
        },
        data_qst_5:function()
        {
            return this.prop_submission == undefined || this.prop_submission.length == 0 ? undefined : this.prop_submission[0].qsts_all["GroupGener0/NHMISnhmis9/NHMISlabHea"];
        }
    }
}

//call all with signature func_imp.call(this,param_1,param_2)
//############################################
//HELPERS
//############################################

//############################################
//API_REQUESTS
//############################################

//############################################
//DATA_OPPS
//############################################

//############################################
//ACTIONS
//############################################
</script>
